import {
  CampaignCardCosmicMetadata,
  useIsCosmicHelperEnabled,
} from '@finn/ui-cosmic';
import { config } from '@finn/ui-utils';
import { useMemo } from 'react';

export type CampaignCardProps = {
  slug: string;
  title: string;
  metadata: CampaignCardCosmicMetadata;
};

const isEnabledForTesting = (allowed: boolean) => {
  return allowed && config?.APP_STAGE !== 'production';
};

export const useCampaignCards = (
  campaignData?: CampaignCardProps[],
  isOutOfStock?: boolean
) => {
  const isCosmicHelperEnabled = useIsCosmicHelperEnabled();

  const activeCampaigns = useMemo(
    () =>
      campaignData
        ?.filter(
          (campaign) =>
            campaign.metadata.enabled === true ||
            isEnabledForTesting(
              Boolean(campaign.metadata?.enabled_for_testing_only)
            )
          // we remove out of stock campaigns if isOutOfStock is false
        )
        .filter(
          (campaign) =>
            !(!isOutOfStock && campaign.metadata?.variant === 'out_of_stock')
        ),
    [campaignData, isOutOfStock]
  );

  const campaignsToShow = isCosmicHelperEnabled
    ? campaignData
    : activeCampaigns;

  return campaignsToShow;
};
